import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { getIssueUrl } from '../../services/client'
import { useClientApiContext } from '../context/ClientApiContextProvider'
import { logout, updateAuthToken } from '../../redux/actions/userActions'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../redux/reducers'
import { routePaths } from '../../constants'

const Magazine = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const id: string | null = searchParams.get('id')
  const token: string | null = searchParams.get('token')
  const article: string | null | undefined = searchParams.get('article')
  const ref: string | null | undefined = searchParams.get('ref')
  const tag: string | null | undefined = searchParams.get('tag')
  const { user } = useSelector((state: RootState) => state)
  const useClientContext = useClientApiContext()
  const [linkExpired, setLinkExpired] = useState(false)

  const displayAlert = () => alert('Unable to open this issue at this time')

  const openMagazine = useCallback(
    (id: string) => {
      getIssueUrl(useClientContext.client, id, article, tag).then(
        (url) => {
          if (url) {
            debugger
            url = ref ? `${url}&ref=${ref}` : url
            window.location.replace(
              window.location.host === 'library-dev.clicknreadmags.com'
                ? `${url}&isDev=true`
                : url
            )
          }
        },
        () => displayAlert()
      )
    },
    // eslint-disable-next-line
    [useClientContext.client]
  )

  useEffect(() => {
    if (linkExpired) {
      // Create uuid and store it if it is not existed
      dispatch(logout())
      navigate(`${routePaths.LOGIN}?token=${token}`)
    }
  }, [dispatch, navigate, linkExpired, token])

  useEffect(() => {
    debugger
    if (token) {
      if (user.id) {
        useClientContext.client
          .loginWithToken(
            { tokenType: 'magic' },
            { token, clientId: user.id, product: 'library' }
          )
          .then(
            (result) => {
              dispatch(updateAuthToken(result.data))
              // open magazine with magic link
              id && openMagazine(id)
            },
            (error) => {
              console.warn('error getting token from magic link, ', error)
              setLinkExpired(true)
            }
          )
      } else {
        id && openMagazine(id)
      }
    }
    // eslint-disable-next-line
  }, [token, user.id])

  useEffect(() => {
    // Open magazine when navigating from library
    const openUrl = () => {
      !token && id && openMagazine(id)
    }
    openUrl()
  })

  return <></>
}

export default Magazine
